import React, {useContext, useEffect, useState} from 'react';
import {AppContext} from '../contexts/context';

// Material UI
// Todo(hoffmannm): use stack with mui v5
// import Stack from '@mui/material/Stack';
import Dialog from '@mui/material/Dialog';
import ClearIcon from '@mui/icons-material/Clear';
import HealingIcon from '@mui/icons-material/Healing';
import DefaultValueIcon from '@mui/icons-material/Replay';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import {createStyles, makeStyles} from '@mui/styles';

import {getAppUrl} from "../containers/AppUrl";
import {createDeviceDataFromResources} from "../models/deviceData";
import {getDeviceResources} from "../models/deviceResources";

// Curated device default-value bundles shown as buttons. Resources are loaded by
// folder id via require.context (see deviceResources) — no per-device imports.
// Only folders with the full initialData* set are valid here. The demo entry
// uses the dedicated demo factory.
const DEVICE_BUNDLES = [
  { deviceId: 'SVD0005E', buttonText: 'SVD0005E' },
  { deviceId: 'EFA0003E', buttonText: 'EFA0003E' },
  { deviceId: 'UK00021E', buttonText: 'UK00021E' },
  { deviceId: 'ABC1234E', buttonText: 'ABC1234E' },
  { deviceId: 'REPAIRDATA', buttonText: 'REPAIR DATA', message: 'Repair Mode', color: 'secondary', icon: 'healing', sx: {marginTop: 2} },
];

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: 16,
    },
    button: {
      marginTop: 10,
      marginRight: 10,
    },
    closeButton: {
      position: 'absolute',
      right: 8,
      top: 8,
      color: theme.palette.grey[500],
    },
  }),
);

const DevDialog = () => {
  const classes = useStyles();
  const [ state, dispatch ] = useContext(AppContext);
  const [ open, setOpen ] = useState(false);

  const myURL = getAppUrl()

  // Load a complete device bundle (schema + all data blocks + compressed schema)
  // in a single dispatch, then mark the scan as done.
  const loadBundle = (bundle) => {
    const deviceData = bundle.build
      ? bundle.build(myURL.href)
      : createDeviceDataFromResources(getDeviceResources(bundle.deviceId), {uri: myURL.href});
    dispatch({type: 'data/device/loaded', value: deviceData});
    dispatch({type: 'ndef/scan/done'});
    dispatch({type: 'app/ui/dialog/default/close'});
    dispatch({
      type: 'app/ui/snackbar/show',
      message: `Default values for ${bundle.message ?? bundle.buttonText} loaded.`,
      severity: 'success'
    });
  }

  const resetData = () =>{
    dispatch({type: 'data/device/reset', value: myURL.href});
    dispatch({
      type: 'app/ui/snackbar/show',
      message: "All values cleared!",
      severity: 'success'
    });
    //Added to enable Write button
    dispatch({type: 'app/env/resetToNoData'});
  }

  const handleClose = () => {
    dispatch({type: 'app/ui/dialog/default/close'});
  };

  // Leave developer mode for this session: the app bar icon (and with it this
  // dialog) is bound to appEnv === 'dev'. A reload resolves the env from the
  // url/hostname again (see resolveEnv).
  const handleExitDevMode = () => {
    dispatch({type: 'app/env/set', value: 'prd'});
    dispatch({type: 'app/ui/dialog/default/close'});
    dispatch({
      type: 'app/ui/snackbar/show',
      message: 'Developer mode disabled.',
      severity: 'success'
    });
  };

  useEffect(() => {
    if (state.uiDialog === 'devmode') {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [state.uiDialog]);

  return (
    <div >
      <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-dev" style={{borderRadius:30}}>
        <DialogTitle id="form-dialog-dev" onClose={handleClose} className={classes.root} variant="h6" sx={{}} >
          Developer Help
        </DialogTitle>
        <DialogContent sx={{flexGrow:1, display:"flex", flexDirection:"column", alignItems:"center"}}>
          <Typography>
          You can restore default values by pressing one of the following buttons.
          </Typography>
        </DialogContent>
        <div className={classes.root} style={{display:"flex", flexDirection:"column", gap:10}}>
          {DEVICE_BUNDLES.map((bundle) => (
            <Button
              key={bundle.buttonText}
              onClick={() => loadBundle(bundle)}
              variant="contained"
              color={bundle.color ?? "primary"}
              startIcon={bundle.icon === 'healing' ? <HealingIcon /> : <DefaultValueIcon />}
              className={classes.button}
              sx={bundle.sx}
              fullWidth
            >
              {bundle.buttonText}
            </Button>
          ))}
          <Button
            onClick={resetData}
            variant="outlined"
            color="primary"
            startIcon={<ClearIcon />}
            className={classes.button}
            fullWidth
          >
            CLEAR DATA
          </Button>
        </div>
        <DialogActions sx={{justifyContent: 'space-between'}}>
          <Button onClick={handleExitDevMode} color="primary">
            Exit
          </Button>
          <Button onClick={handleClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default DevDialog;
